import { createSelector } from 'reselect';
import { FhaSegment, FHA_KEY } from '../types';
import { getViewIndex } from './commonSelectors';
import { getCurrentSeasonLayer } from './layerSelectorsNew';

export const getFha = createSelector(
  [getCurrentSeasonLayer],
  (currentSeasonLayer) => currentSeasonLayer?.[FHA_KEY]
);

export const getFhaDate = createSelector(
  [getFha, getViewIndex],
  (fha, index) => fha?.activeSubLayerIds[index]?.date
);

export const getIsFhaSubLayerActive = createSelector(
  [getFha, getViewIndex],
  (fha, index) => Boolean(fha?.activeSubLayerIds[index]?.layer === FhaSegment.TRUE_COLOR)
)

export const getFhaSelectedSegment = createSelector(
  [getFha, getViewIndex],
  (fha, index) => fha?.activeSubLayerIds[index]?.segmentSelected
);
